export const getStatusLabel = (status: string): string => {
  switch (status) {
    case 'REQUESTED':
      return 'Solicitado';
    case 'APPROVED':
      return 'Aprobado';
    case 'CONFIRMED':
      return 'Confirmado';
    case 'REJECTED':
      return 'Rechazado';
    case 'CANCELLED':
      return 'Cancelado';
    default:
      return status;
  }
};

// 🎨 Colores reutilizables del sistema
export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'REQUESTED':
      return 'bg-[#F9C107] text-[#212B36]'; // Warning
    case 'APPROVED':
      return 'bg-[#3BA2B8] text-white'; // Info
    case 'CONFIRMED':
      return 'bg-[#3CA745] text-white'; // Success
    case 'REJECTED':
      return 'bg-[#DC3545] text-white'; // Danger
    case 'CANCELLED':
      return 'bg-[#637381] text-white'; // Gray
    default:
      return 'bg-[#EFEFEF] text-[#212B36]'; // Light
  }
};
